// extracted by mini-css-extract-plugin
export default {"dropDownAndAudio":"style_dropDownAndAudio__34Fuj","cardParent":"style_cardParent__rGRJo","responsive":"style_responsive__sBHiR","inResponsive":"style_inResponsive__tKvsO"};